import { render, staticRenderFns } from "./corporateBigData.vue?vue&type=template&id=6feb19dd&scoped=true"
import script from "./corporateBigData.vue?vue&type=script&lang=js"
export * from "./corporateBigData.vue?vue&type=script&lang=js"
import style0 from "./corporateBigData.vue?vue&type=style&index=0&id=6feb19dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feb19dd",
  null
  
)

export default component.exports